"use strict";var $export=require("./_export");$export($export.S,"Number",{isInteger:require("./_is-integer")});